/**
 * 品牌管理表格列定义
 * 职责: 定义品牌列表的表格列
 * 限制: <100行
 */

import React from 'react';
import { Button, Space, Popconfirm, Tag } from 'antd';
import { EditOutlined, DeleteOutlined, CheckCircleOutlined, StopOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { BrandListItem } from '../../services/brandService';

interface BrandTableColumnsProps {
  onEdit: (record: BrandListItem) => void;
  onDelete: (id: number) => void;
  onToggleActive: (id: number) => void;
}

export const createBrandTableColumns = ({
  onEdit,
  onDelete,
  onToggleActive,
}: BrandTableColumnsProps): ColumnsType<BrandListItem> => [
  {
    title: '品牌名称',
    dataIndex: 'name',
    key: 'name',
    width: 200,
  },
  {
    title: '品牌原型',
    dataIndex: 'archetype',
    key: 'archetype',
    width: 150,
  },
  {
    title: '语气/风格',
    dataIndex: 'tone',
    key: 'tone',
    ellipsis: true,
    width: 200,
  },
  {
    title: '关联SKU数',
    dataIndex: 'sku_count',
    key: 'sku_count',
    width: 100,
    align: 'center',
  },
  {
    title: '状态',
    dataIndex: 'is_active',
    key: 'is_active',
    width: 100,
    render: (is_active: boolean) => (
      is_active ? (
        <Tag color="success" icon={<CheckCircleOutlined />}>激活</Tag>
      ) : (
        <Tag color="default" icon={<StopOutlined />}>停用</Tag>
      )
    ),
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 180,
    render: (text: string) => new Date(text).toLocaleString('zh-CN'),
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 200,
    render: (_, record) => (
      <Space size="small">
        <Button type="link" size="small" icon={<EditOutlined />} onClick={() => onEdit(record)}>
          编辑
        </Button>
        <Button 
          type="link" 
          size="small"
          onClick={() => onToggleActive(record.id)}
        >
          {record.is_active ? '停用' : '激活'}
        </Button>
        <Popconfirm
          title="确认删除"
          description={`确定要删除品牌"${record.name}"吗？${record.sku_count > 0 ? '（该品牌还有关联的SKU）' : ''}`}
          onConfirm={() => onDelete(record.id)}
          okText="确定"
          cancelText="取消"
          disabled={record.sku_count > 0}
        >
          <Button 
            type="link" 
            danger 
            size="small" 
            icon={<DeleteOutlined />}
            disabled={record.sku_count > 0}
          >
            删除
          </Button>
        </Popconfirm>
      </Space>
    ),
  },
];

